module.exports = __webpack_public_path__ + "img/history.93c228af.png";